export enum DatePickerType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  SINGLE_MONTHLY = 'SINGLE_MONTHLY'
}

export enum DatePickerSelectType {
  DAY = 'DAY',
  WEEK = 'WEEK'
}

export const YEARS_PER_PAGE = 12;
